import * as React from 'react';
import { WithRouterProps } from 'react-router';

import assertions from 'lib/assertions';
import Button from 'components/ButtonDeprecated';
import createChainedFunction from 'utils/createChainedFunction';
// @ts-ignore
import Device from 'entities/Device';
// @ts-ignore
import DividerText from 'components/DividerText';
import EventTracking from 'lib/EventTracking';
import FormElement from 'components/FormElement';
// @ts-ignore
import GoogleSignIn from 'auth/components/GoogleSignIn';
import HelpIcon from 'components/HelpIcon';
import Input from 'components/Input';
// @ts-ignore
import RecipientParser from 'lib/RecipientParser';
import ToastActions from 'actions/ToastActions';
import TosText from 'components/TosText';
import { withRouter } from 'app/context/Router';

type Props = {
  onUidSubmit: (deviceUid: string, deviceType: string, fullName: string) => void;
  onUserCreate: () => void;
} & WithRouterProps;

type Status = 'initial_form' | 'device_confirmation';
type State = {
  deviceUid: string;
  fullName: string;
  status: Status;
};

class JoinSignUpForm extends React.Component<Props, State> {
  state: State = {
    status: 'initial_form',
    deviceUid: '',
    fullName: '',
  };

  triggerTosViewEvent = () => {
    EventTracking.trackKey('tos_and_pp.view');
  };

  submitEnabled = (): boolean => {
    return !!this.state.deviceUid && !!this.state.fullName;
  };

  submitUid = () => {
    const { deviceUid, fullName } = this.state;
    const apiFormattedAddress = RecipientParser.newToken(deviceUid).address;
    const deviceType = apiFormattedAddress.startsWith('sms://') ? 'phoneNumber' : 'email';

    const goToSignIn = () => {
      this.props.router.push({ pathname: '/log_in' });
      ToastActions.showSuccessToast('Looks like you already have an account. Log in below.');
    };

    const continueVerification = () => {
      this.props.onUidSubmit(deviceUid, deviceType, fullName);
    };

    Device.belongsToFullAccount(apiFormattedAddress).then(goToSignIn, continueVerification);
  };

  render() {
    const uidLabel = (
      <span>
        Email or phone number
        <HelpIcon
          tooltipText={`Enter your phone number to receive messages by text or your email address to receive
            messages by email. You can always change this later.`}
        />
      </span>
    );

    return (
      <div className="JoinSignUpForm">
        <FormElement
          label="Full name"
          data-test-selector="full-name"
          validate={e => {
            assertions.firstAndLastName(e.target.value);
          }}
          onValidChange={e => this.setState({ fullName: e.target.value })}
          onInvalidChange={() => this.setState({ fullName: '' })}
          element={Input}
          elementProps={{
            className: 'JoinSignUpForm-input',
            placeholder: 'First and last name',
            name: 'fullName',
          }}
        />
        <FormElement
          label={uidLabel}
          data-test-selector="device-uid"
          validate={e => {
            assertions.emailOrPlausibleNorthAmericanPhoneNumber(
              e.target.value,
              'Invalid email or phone number.'
            );
          }}
          onValidChange={e => this.setState({ deviceUid: e.target.value })}
          onInvalidChange={() => this.setState({ deviceUid: '' })}
          element={Input}
          elementProps={{
            className: 'JoinSignUpForm-input',
            placeholder: 'Enter your email or phone number',
            name: 'deviceUid',
          }}
        />
        <Button
          className="JoinSignUpForm-submit"
          disabled={!this.submitEnabled()}
          level="primary"
          full
          type="submit"
          eventElementName="JoinSignUpForm-Submit"
          onClick={this.submitUid}>
          Sign up
        </Button>

        <DividerText uppercase>or</DividerText>

        <div className="block">
          <GoogleSignIn
            body="Sign up with Google"
            onSuccess={createChainedFunction(this.props.onUserCreate, this.triggerTosViewEvent)}
          />
        </div>

        <TosText className="JoinSignUpForm-tos" />
      </div>
    );
  }
}
export { JoinSignUpForm };
export default withRouter(JoinSignUpForm);
